<template>
    <div>
        <div v-html="text"></div>
    </div>
</template>

<script>
    export default {
        name: "TermsConditions",
        data: function () {
            return {
                text: null,
            }
        },
        props: [
            'type',
            'vehicles',
            'user'
        ],
        mounted() {
            if (this.type === 'termos_de_uso') {
                axios.get('/api/webdriver/landpage', {params: {tags: 'termos_de_uso'}}).then(res => {
                    this.text = res.data.data[0].content;
                });
            } else if (this.type === 'termos_de_uso_ativacao_automatica_web') {
                axios.get('/api/webdriver/landpage', {params: {tags: 'termos_de_uso_ativacao_automatica'}}).then(res => {
                    let plate = this.vehicles.map(o => o['plate']).join(', ');
                    let date = moment(new Date).format('LL');
                    let identification = this.identificationToPattern(this.user.identification);
                    let name = this.user.name.toUpperCase();

                    this.text = res.data.data[0].content.replace("{{plate}}", plate)
                                    .replace("{{name}}", name)
                                    .replace("{{identification}}", identification)
                                    .replace("{{date}}", date);
                });
            }
        }
    }
</script>

<style scoped>
    p {
        font-size: 14px;
        font-family: Roboto-Regular;
        color: #595959;
    }
</style>
